module.exports = __webpack_public_path__ + "img/secondary_8x4_z18.bbd3315e.svg";